import type { HtmlViewerMessage } from "../../../shared/htmlViewer";
import { HTML_VIEWER_ROUTE } from "../../../shared/reservedRoutes";
import { openIsolatedFrame } from "../../lib/openIsolatedFrame";

export function openIsolatedBlob(
  blob: Blob,
  title: string,
  edgeOrigin: string
) {
  const viewer = openIsolatedFrame(
    title,
    `${edgeOrigin}${HTML_VIEWER_ROUTE}`,
    "allow-scripts"
  );
  if (!viewer) return;
  const { popup, frame } = viewer;
  frame.addEventListener("load", () => {
    const viewer = frame.contentWindow;
    if (!viewer) return;
    const channel = new MessageChannel();
    viewer.postMessage({ type: "init" }, "*", [channel.port2]);
    const render: HtmlViewerMessage = { type: "renderBlob", data: blob };
    channel.port1.postMessage(render);
  });
  popup.document.body.appendChild(frame);
}
